// utils
import _ from 'lodash';

/**
 * represents an instance of pad creator
 * @class PadCreator
 */
export default class PadCreator {
  /**
   * @param {object} state - pad creator element state
   * @returns {this}
   */
  constructor(state) {
    if (new.target === PadCreator) {
      throw new Error('PadCreator is an abstract class.');
    }

    this._state = _.cloneDeep(state);
    this._loadedData = _.cloneDeep(state.data.loaded);
    this._screenData = _.cloneDeep(state.data.screen);
    this._submitData = _.cloneDeep(state.data.submit);
  }

  /**
   * get state.
   * @returns {object} the pad creator element state
   */
  getState() {
    this._state.data.loaded = this._loadedData;
    this._state.data.screen = this._screenData;
    this._state.data.submit = this._submitData;

    return this._state;
  }

  /**
   * change loading state.
   * * @param {Boolean} Boolean - state of loading.
   * @returns {this}
   * @default Boolean is true
   */
  setLoading(paramBoolean = true) {
    this._state.loading = paramBoolean;

    return this;
  }

  setErrors(errors = []) {
    this._state.errors = errors;

    return this;
  }
}
